import { Outlet } from 'react-router-dom';
import { MiraSidebarLayout } from '../components/MiraSidebarlayout';
import { useSession } from '../hooks/useSession';
import { useCoreData } from '../contexts/CoreDataContext';

/**
 * Main application layout with sidebar navigation
 */
export function AppLayout() {
  const { user } = useSession();
  const { coreData } = useCoreData();

  if (!user) {
    return null;
  }

  // Extract module availability from core data
  const modules = coreData?.modules ? {
    absence_overview: coreData.modules.find(m => m.name === 'absence_overview')?.enabled ?? false,
    absence_requests: coreData.modules.find(m => m.name === 'absence_requests')?.enabled ?? false,
  } : undefined;

  return (
    <MiraSidebarLayout user={user} modules={modules}>
      <Outlet />
    </MiraSidebarLayout>
  );
}

